<template>
  <Card :title="$tc('attachment', 2) + ` (${items.length})`" class="comment-files">
    <template #default>
      <template v-if="items.length">
        <FileItem v-for="file in items" :key="file.url" :value="file" />
        <Alert class="mt-1">{{ $tc('externalFileDisclaimer') }}</Alert>
      </template>
      <i v-else class="fade">{{ $t('noAttachments') }}</i>
    </template>
  </Card>
</template>
<script>
import Card from '@kvass/card'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { Clone } from '@/utils'
import FileItem from './FileItem.vue'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return Clone(this.value)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map(v => v.attachments)
        .flat()
        .filter(Boolean)
    },
  },
  components: {
    Card,
    Alert,
    FileItem,
  },
}
</script>

<style lang="scss">
.comment-files {
  .comment-file + .comment-file {
    margin-top: 0.5rem;
  }
}
</style>
